import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";

export interface UserPromptSettingsData {
	prompt_text: string | null;
	updated_at?: string | null;
	version?: number | null;
}

export type IGetUserPromptSettingsResponse = IResponse<UserPromptSettingsData>;
export type IUpdateUserPromptSettingsResponse =
	IResponse<UserPromptSettingsData>;

export async function getUserPromptSettings(): Promise<IGetUserPromptSettingsResponse> {
	return await apiRequest<UserPromptSettingsData>({
		path: "/api/user-prompt-settings",
		method: "GET",
	});
}

export async function updateUserPromptSettings(body: {
	prompt_text: string;
}): Promise<IUpdateUserPromptSettingsResponse> {
	return await apiRequest<UserPromptSettingsData>({
		path: "/api/user-prompt-settings",
		method: "PUT",
		json: body,
	});
}
